import { useState, useCallback } from 'react';
import { PaywallConfig, PaywallState } from '@/types/paywall';

export const usePaywall = () => {
  const [paywallState, setPaywallState] = useState<PaywallState>({
    isOpen: false,
    config: null,
    onBack: undefined
  });

  const openPaywall = useCallback((config: PaywallConfig, onBack?: () => void) => {
    setPaywallState({
      isOpen: true,
      config,
      onBack
    });
  }, []);

  const closePaywall = useCallback(() => {
    setPaywallState(prev => ({
      ...prev,
      isOpen: false
    }));
  }, []);

  const clearPaywall = useCallback(() => {
    setPaywallState({
      isOpen: false,
      config: null,
      onBack: undefined
    });
  }, []);

  return {
    isOpen: paywallState.isOpen,
    config: paywallState.config,
    onBack: paywallState.onBack,
    openPaywall,
    closePaywall,
    clearPaywall
  };
};